import {
    CONFIRMED_GET_BANKS
} from '../actions/bank/BankTypes';
const initialState = {
    banks: [],
    loading: false,
};

function BankReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'BANK_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_BANKS:
            return {
                ...state,
                banks: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {BankReducer};